import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAJmMHE43KulrvOC-SJPXDxZlTN0B8qvVU",
  authDomain: "core6-marketing.firebaseapp.com",
  projectId: "core6-marketing",
  storageBucket: "core6-marketing.firebasestorage.app",
  messagingSenderId: "159628577122",
  appId: "1:159628577122:web:31904a8d7dae02650d843b",
  measurementId: "G-8BWTRE1XN3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
